/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from '@/store';
import axios from "axios";
import Vant from 'vant';
import { Lazyload } from 'vant';
import 'vant/lib/index.css';
import Config from './config/config-1'
// import VeeValidate, { Validator } from 'vee-validate'
// import zhCN from 'vee-validate/dist/locale/zh_CN'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import myCharts from '@/utils/echartsOption.js'
import 'lib-flexible/flexible'

// import Vconsole from "vconsole";
// new Vconsole()

Vue.use(ElementUI)
Vue.use(myCharts)
import '@/assets/public.css'
import '@/assets/public.scss'
// const store = new Vuex.Store(storeData);

import Common from '@/views/carbonHuihuzhou/carbonMini/common/js/common.js';
import '@/views/carbonHuihuzhou/carbonMini/common/js/date.js';
import '@/views/carbonHuihuzhou/carbonMini/common/css/common.scss';
Vue.prototype.$common = Common;
Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(Vuex)
Vue.use(store)

Vue.config.productionTip = false
Vue.prototype.$Config = Config
import VueCupUi from 'vue-cup-ui';
import 'vue-cup-ui/lib/vue-cup-ui.css';
Vue.use(VueCupUi);
// Vue.use(VeeValidate, {
//   events: 'blur',
// })
// Validator.localize('zhCN', zhCN)

// sessionStorage.setItem('userId', '2088702183270372')
// sessionStorage.setItem('userId', 'a73450a324864f009b04d3e16c6c046a')
// sessionStorage.setItem('once', '111')

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
//请求拦截
axios.interceptors.request.use(function (config) {
  console.log(config)
  if(localStorage.getItem('token') && localStorage.getItem('id')){
      config.headers.Authorization = 'Bearer ' + localStorage.getItem('token')
  }
  return config
}, function (error) {
  return Promise.reject(error)
});
// 结果 拦截器
axios.interceptors.response.use(
  response => {

      //请注意，这里服务端返回的response.data.code的类型为数字类型，如果写为"104"是不相等的，如果那样，页面数据会没有，也没有提示用户超时登录信息。
      if(response && response.data && response.data.code === 104){
          let token = storage.getLoginUserTokenStorage();
          if(token){
              ViewUI.Message.warning("登录超时！");
              storage.removeLoginUserTokenStorage();
              //防止提示超时登录跳到首页的时候，一直显示转圈加载中。
              layui.use('table', function () {
                layer.closeAll();
              })
          }
          // 退出时清空用户信息
          storage.removeLoginUserInfoStorage();
          // 退出时清空菜单信息
          storage.removeMenuTreeStorage();
          storage.removeMenuArrayStorage();
          // 拦截
          router.push({ path: "/login" });
      }

    return response;
  },
  error => {
    let response = {};
    // 请求路径
    let path = error.response.data.path;
    // 错误处置
    if (error.response) {
        switch (error.response.status) {
            case 401:
              break;
            case 404:
                if(path && path.indexOf("getPage") > -1){
                    response.data = {data: [], total: 0, success: false, message: "网络异常"};
                }else{
                    response.data = {success: false, data: {}, message: "网络异常"};
                }
                break;
            case 403:
              break;
            case 500:
                response.data = {success: false, message: "服务异常"};
                break;
        }
    }
    return response; // 返回接口返回的错误信息
  }
);


// WEBPACK FOOTER //
// ./src/main.js